import { useCallback } from "react";
import { AppConstants, PlatformApi } from "../../configs";
import { AxiosAuth } from "../../core";
import { ApiResponse } from "../../models";
import {
  CallRecordingAccessUrlResponseModel,
  CallRecordingResponseModel,
  CallRetentionSettingRequest,
} from "../../models/api/callRecording";

export function useFunctionalityCallRecording() {
  const LoadByCallId = useCallback(async (callId: string) => {
    const url = PlatformApi.CallRecording.GetByCall(callId);
    try {
      const res = await AxiosAuth.get<ApiResponse<CallRecordingResponseModel>>(url);
      if ((res.status = AppConstants.Api.StatusOK)) {
        return Promise.resolve(res.data.data);
      }
    } catch (e) {
      return Promise.reject(e);
    }
  }, []);

  const LoadAccessUrl = useCallback(
    async (
      callRecordingId: string,
      asDownload?: boolean,
      expiresInMinutes?: number
    ) => {
      const url = PlatformApi.CallRecording.GetAccessUrl(
        callRecordingId,
        asDownload,
        expiresInMinutes
      );
      try {
        const res = await AxiosAuth.get<ApiResponse<CallRecordingAccessUrlResponseModel>>(url);
        if ((res.status = AppConstants.Api.StatusOK)) {
          return Promise.resolve(res.data.data);
        }
      } catch (e) {
        return Promise.reject(e);
      }
    },
    []
  );

  const CreateCallRetentionSetting = useCallback(
    async (companyId: string, payload: CallRetentionSettingRequest) => {
      const url = PlatformApi.CompanySettings.CreateCallRetentionSetting(companyId);
      try {
        const res = await AxiosAuth.post<ApiResponse<boolean>>(url, payload);
        if ((res.status = AppConstants.Api.StatusOK)) {
          return Promise.resolve(res.data.data);
        }
      } catch (e) {
        return Promise.reject(e);
      }
    },
    []
  );

  const UpdateCallRetentionSetting = useCallback(
    async (callRetentionSettingId: string, payload: CallRetentionSettingRequest) => {
      const url = PlatformApi.CompanySettings.UpdateCallRetentionSetting(callRetentionSettingId);
      try {
        const res = await AxiosAuth.put<ApiResponse<boolean>>(url, payload);
        if ((res.status = AppConstants.Api.StatusOK)) {
          return Promise.resolve(res.data.data);
        }
      } catch (e) {
        return Promise.reject(e);
      }
    },
    []
  );

  return {
    LoadByCallId,
    LoadAccessUrl,
    CreateCallRetentionSetting,
    UpdateCallRetentionSetting,
  };
}
